<script>
  import { DwoomCloudConferenceClient } from '@dwoom/cloud-conference-javascript-client';
  //import { DwoomCloudConferenceClient } from '../../../lib/index.umd';
  import { tick, onMount } from 'svelte';

  import Peer from './peerGrid/peer.svelte';
  import Button from './button.svelte';
  import Container from './container.svelte';
  import Input from './input.svelte';
  import RingLoadingSpinner from './ringLoadingSpinner.svelte';
  import DeviceSelect from './deviceSelect.svelte';
  import ActionBar from './actionBar.svelte';
  import Header from './header.svelte';

  let client;

  let joined = false;
  let joinLoading = false;
  let accessToken = '';
  //
  let sharingAudio = false;
  let sharingVideo = true;
  let sharingScreen = false;
  //
  let sharingAudioLoading = false;
  let sharingVideoLoading = false;
  let sharingScreenLoading = false;
  // Contains all the user's devices such as it's mics, webcams, outputs.
  let video;
  let devices = [];
  // Do we have access to it's devices?
  let asDeviceAccess = false;
  let loadingDeviceAccess = true;
  // Users in the same room
  let peers = [];

  onMount(async () => {
    await requestDevices();
  });

  $: {
    if (micId) {
      requestDevices();
    }
    if (webcamId) {
      requestDevices();
    }
  }

  async function getCurrentDevice() {
    let micDeviceConstraints = {};
    let camDeviceConstraints = {};
    if (micId) micDeviceConstraints = { deviceId: { exact: micId } };
    if (webcamId) camDeviceConstraints = { deviceId: { exact: webcamId } };
    let device = await navigator.mediaDevices.getUserMedia({
      audio: { ...micDeviceConstraints, noiseSuppression: true, echoCancellation: true },
      video: { ...camDeviceConstraints, width: 1280, height: 720 },
    });
    return device;
  }

  async function requestDevices() {
    loadingDeviceAccess = true;
    try {
      video.srcObject = await getCurrentDevice();
      video.play();
      devices = await navigator.mediaDevices.enumerateDevices();
      asDeviceAccess = true;
    } catch (e) {
      console.log(e);
    }
    loadingDeviceAccess = false;
  }

  async function joinRoom() {
    joinLoading = true;
    client = new DwoomCloudConferenceClient(accessToken, true);
    client.addEventListener('peer-join', ({ detail }) => {
      peers.push(detail.peerId);
      peers = peers;
      console.log('peer joined');
    });

    client.addEventListener('peer-create-producer', async ({ detail }) => {
      let peersToConsume = [];
      for (let [id, peer] of client.peers) {
        for (let [mediaTag, _] of peer.medias) {
          peersToConsume.push({ peer_id: id, media_tag: mediaTag });
        }
      }
      await client.consumeProducers(peersToConsume);
      await updatePeerAndMedias();
    });

    client.addEventListener('peer-removed', async ({ detail }) => {
      /*if (videoGrid) {
      for (let video of videoGrid.children) {
        console.dir(video);
        console.dir(detail);
        if (video.consumer.producerPeerId === detail.peerId) {
          videoGrid.removeChild(video);
        }
      }
    }*/
      peers = client.peers;
    });

    let volumes = [];

    client.addEventListener('room-volumes-level-changed', async ({ detail }) => {
      /*if (videoGrid) {
      for (let video of videoGrid.children) {
        console.dir(video);
        console.dir(detail);
        if (video.consumer.producerPeerId === detail.peerId) {
          videoGrid.removeChild(video);
        }
      }
    }*/
      volumes = detail.volumes;
      peers = client.peers;
    });
    let res = await client.tryJoin();

    if (res.ok) {
      let peersToConsume = [];
      for (let [id, peer] of client.peers) {
        peers.push(id);
        for (let [mediaTag, _] of peer.medias) {
          peersToConsume.push({ peer_id: id, media_tag: mediaTag });
        }
      }
      peers = peers;
      await client.consumeProducers(peersToConsume);
      joined = true;
      await updatePeerAndMedias();

      let producer = await getCurrentDevice();
      sharingAudio = true;
      sharingVideo = true;
      await client.produce(producer.getVideoTracks()[0], 'cam-video', 'video');
      await client.produce(producer.getAudioTracks()[0], 'mic-audio', 'audio');
    }
    joinLoading = false;
  }

  async function handleCameraClick() {
    let producer = client.producers.filter((v) => v.appData.media_tag === 'cam-video')[0];
    if (producer) {
      sharingVideoLoading = true;
      if (sharingVideo) {
        await client.resumeProducer(producer);
      } else {
        await client.pauseProducer(producer);
      }
      sharingVideoLoading = false;
    }
  }

  async function handleMicClick() {
    let producer = client.producers.filter((v) => v.appData.media_tag === 'mic-audio')[0];
    if (producer) {
      sharingAudioLoading = true;
      if (sharingAudio) {
        await client.resumeProducer(producer);
      } else {
        await client.pauseProducer(producer);
      }
      sharingAudioLoading = false;
    }
  }

  async function handleScreenClick() {}

  async function mutePeer(producerPeerId, e) {
    console.log('mutePeer', producerPeerId, e);
    let media = client.peers.get(producerPeerId).medias.get('mic-audio');
    if (media.some) {
      if (e.detail.isMuted) {
        await client.pauseConsumer(media.val);
      } else {
        await client.resumeConsumer(media.val);
      }
    }
  }

  let webcamId;
  let micId;
  let outId;

  let videoGrid;

  async function createMediaEl(consumer, type) {
    let peerFound = false;
    for (let media of videoGrid.children) {
      if (media.id === consumer.producerPeerId) {
        peerFound = true;
        new Peer('test');
      }
    }

    if (!peerFound) {
    }

    /*let el = document.createElement(type);
    videoGrid.appendChild(el);
    el.srcObject = new MediaStream([consumer.consumer.track.clone()]);
    el.consumer = consumer;
    await el.play();*/
  }

  let dumb_peer = new Map();

  for (let el in [...Array(3).keys()]) {
    dumb_peer.set(el, null);
  }

  let dumb_peerAndMedias = [];
  dumb_peer.forEach((value, key) => {
    dumb_peerAndMedias.push({
      peerId: key,
      cam: undefined,
      mic: undefined,
      out: undefined,
    });
  });

  async function updateUi() {
    await tick();
    if (videoGrid) {
      for (let consumer of client.webrtcConsumers) {
        if (consumer.producerMediaTag === 'cam-video') {
          await createMediaEl(consumer, 'video');
        } else if (consumer.mediaTag === 'mic-audio') {
          await createMediaEl(consumer, 'audio');
        }
      }
    }
  }

  let peersAndMedias = [];
  let peersComponents = {};

  async function updatePeerAndMedias() {
    //console.log('peersAndMedias', peersAndMedias);
    //console.log('peersComponents', peersComponents);
    await tick();
    console.log(client.peers);
    for (const [peerId, peer] of client.peers) {
      console.log('updating peer component', peerId);
      let videoCam = peer.medias.get('cam-video');
      let audioMic = peer.medias.get('mic-audio');
      console.log('videoCam', videoCam);
      console.log('audioMic', audioMic);
      let volume = client.volumes.filter((v) => v.producerId === audioMic.producerId);

      if (videoGrid) {
        let component = peersComponents[peerId];
        console.log('component', component);
        if (component) {
          if (!component.videoConsumer) {
            console.log('!component.videoConsumer');
            component.videoConsumer = videoCam && videoCam.some ? videoCam.val : undefined;
            await component.playVideo();
          }
          if (!component.audioConsumer) {
            console.log('!component.audioConsumer');
            component.audioConsumer = audioMic && audioMic.some ? audioMic.val : undefined;
            await component.playAudio();
          }
        }
      }
    }
  }
</script>

<main>
  {#if false}
    <Header />
    <div class="call-wrapper">
      <div
        class="video-grid"
        class:video-grid-1-peer={dumb_peer.size === 1}
        class:video-grid-2-peers={dumb_peer.size === 2}
        class:video-grid-3-peers={dumb_peer.size === 3}
        class:video-grid-4-peers={dumb_peer.size === 4}
        bind:this={videoGrid}
      >
        {#each dumb_peerAndMedias as peerAndMedias (peerAndMedias.peerId)}
          <Peer
            videoConsumer={peerAndMedias.cam}
            audioConsumer={peerAndMedias.audio}
            peerName={peerAndMedias.peerId}
            volume={peerAndMedias.volume}
          />
        {/each}
      </div>
    </div>
    <ActionBar
      bind:sharingAudio
      bind:sharingScreen
      bind:sharingVideo
      bind:sharingAudioLoading
      bind:sharingScreenLoading
      bind:sharingVideoLoading
      on:cameraClick={handleCameraClick}
      on:micClick={handleMicClick}
      on:screenClick={handleScreenClick}
    />
  {:else if !joined}
    <div class="wrapper">
      <Container width="580px">
        <div class="container-group-larger">
          <div class="container-group">
            <div class="cam-preview" class:clickable={!asDeviceAccess} on:click={requestDevices}>
              {#if !asDeviceAccess && !loadingDeviceAccess}
                <p class="cam-autorize-p">
                  Authorize access to your webcam and microphone<br />by clicking here
                </p>
              {:else if loadingDeviceAccess}
                <div class="cam-loading"><RingLoadingSpinner size="1.5em" color="#ffffff" /></div>
              {/if}
              <video bind:this={video} class="cam-preview-video" class:show-cam-preview={asDeviceAccess} muted />
            </div>
            <DeviceSelect {devices} bind:camValue={webcamId} bind:micValue={micId} />
          </div>
          <div class="container-group">
            <Input label="Room access token" bind:value={accessToken} />
            <Button label="Join room" on:click={() => joinRoom()} isLoading={joinLoading} />
          </div>
        </div>
      </Container>
    </div>
  {:else}
    <Header />
    <div class="call-wrapper">
      <!--
      <div class="peer-list">
        <ul>
          {#each [...peers] as [key, value]}
            <li>{key}</li>
          {/each}
        </ul>
      </div>
    -->

      <div
        class="video-grid"
        class:video-grid-1-peer={peers.length === 1}
        class:video-grid-2-peers={peers.length === 2}
        class:video-grid-3-peers={peers.length === 3}
        class:video-grid-4-peers={peers.length === 4}
        class:video-grid-5-peers={peers.length === 5}
        bind:this={videoGrid}
      >
        {#each peers as peerId (peerId)}
          <Peer
            peerName={peerId}
            volume={undefined}
            on:muteButtonClick={(e) => mutePeer(peerId, e)}
            bind:this={peersComponents[peerId]}
          />
        {/each}
      </div>
    </div>
    <ActionBar
      bind:sharingAudio
      bind:sharingScreen
      bind:sharingVideo
      on:cameraClick={handleCameraClick}
      on:micClick={handleMicClick}
      on:screenClick={handleScreenClick}
    />
  {/if}
</main>

<style>
  main {
    height: 100vh;
  }
  .call-wrapper {
    padding: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  main {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    align-content: space-between;
    justify-content: space-between;
    height: 100vh;
  }
  .video-grid {
    display: grid;
    align-content: center;
    grid-gap: 30px;
  }
  .video-grid-1-peer {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
  .video-grid-2-peers {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }
  .video-grid-3-peers {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }
  .video-grid-4-peers {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
  .video-grid-5-peers {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .container-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .container-group-larger {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
  .cam-preview {
    width: 100%;
    padding-top: 56.25%;
    height: 0px;
    position: relative;
    background: #253045;
    border-radius: 10px;
    transition: all 0.3s ease;
  }
  .cam-autorize-p {
    color: #ffffff;
    margin-top: -30%;
    width: 100%;
    text-align: center;
    transition: all 0.3s ease;
    pointer-events: none;
  }
  .cam-loading {
    margin-top: -30%;
  }
  .clickable:hover {
    cursor: pointer;
    background: #161e2f;
  }
  .cam-preview-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 10px;
  }
  .show-cam-preview {
    opacity: 100;
  }
</style>
